import * as constants from './config/constants.js';
import RequestHandler from './utils/request-handler.js';
import ResponseHandler from './utils/response-handler.js';

export default class Ratings {
    constructor() {
        this.identifier = 'data-ratings';
        this.selector = '[' + this.identifier + ']';
        this.requestHandler = new RequestHandler;
        this.responseHandler = new ResponseHandler;
    }

    setup() {
        const ratingElements = this.getRatingElements();
        let skus = new Set();
        ratingElements.forEach(function(el) {
            const sku = this.getRatingDataAttribute(el);
            if (!sku) {
                return;
            }
            skus.add(sku);
        }.bind(this));
        const params = {
            skus: [...skus].join(',')
        };
        this.requestHandler.get(
            constants.BASEPATH + '/ajax/review-ratings.json', params, this.dataCallback.bind(this)
        );
    }

    dataCallback(response) {
        if (!response.success) {
            return;
        }
        response.data.forEach(function(data) {
            const params = {
                sku: data.sku,
                avgRating: data.avgRating,
                totalRatings: data.totalRatings
            };
            this.requestHandler.get(
                constants.CHECKOUTPATH + '/item-ratings', params, this.htmlCallback.bind(this)
            );
        }.bind(this));
    }

    htmlCallback(response) {
        if (this.responseHandler.isSuccess(response)) {
            const data = this.responseHandler.getData(response);
            const ratingElements = this.getRatingElements();
            ratingElements.forEach(function(el) {
                const sku = this.getRatingDataAttribute(el);
                if (!sku || sku !== data.sku) {
                    return;
                }
                el.innerHTML = data.html;
            }.bind(this));
        } else {
            console.error(this.responseHandler.getErrors(response), 'Ratings: html Callback error');
        }
    }

    getRatingElements() {
        return document.querySelectorAll(this.selector);
    }

    getRatingDataAttribute(el) {
        return el.getAttribute(this.identifier);
    }
}
